import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Entries from '../views/Entries.vue'
import Appointments from '../views/Appointments.vue'
import Users from '../views/Users.vue'
import Report from '../views/Report'
import PrintConfig from '../views/PrintConfig'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/entries',
    name: 'entries',
    component: Entries
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: Appointments
  },
  {
    path: '/print-config',
    name: 'print-config',
    component: PrintConfig
  },
  {
    path: '/users',
    name: 'users',
    component: Users
  },
  {
    path: '/report',
    name: 'report',
    component: Report
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
